import { useEffect, useRef } from 'react';
import Config from '../../config';

const useServerSentEvents = (userId: string, onMessageCallback: CallableFunction) => {
    // 1. Usamos un ref para el callback para evitar que el efecto se reinicie 
    // si la función 'onMessageCallback' cambia en cada render del padre.
    const savedCallback = useRef(onMessageCallback);

    useEffect(() => {
        savedCallback.current = onMessageCallback;
    }, [onMessageCallback]);

    useEffect(() => {
        if (!userId) return;

        let eventSource: EventSource | null = null;
        let reconnectTimeout: string | number | NodeJS.Timeout | null | undefined = null;

        // Función encargada de conectar
        const connect = () => {
            const url = `${Config.server.api.securityApi}events/${userId}`;
            console.log(`Intentando conectar SSE a: ${url}`);

            eventSource = new EventSource(url);

            eventSource.onopen = () => {
                console.log("Conexión SSE establecida exitosamente.");
                // Si teníamos un timeout pendiente, lo limpiamos
                if (reconnectTimeout) clearTimeout(reconnectTimeout);
            };

            eventSource.onmessage = (event) => {
                try {
                    const data = JSON.parse(event.data);
                    // Usamos el ref actual para ejecutar el callback
                    if (savedCallback.current) {
                        savedCallback.current(data);
                    }
                } catch (err) {
                    console.error("Error parseando data SSE:", err);
                }
            };

            eventSource.onerror = (err) => {
                console.error("Error en conexión SSE (servidor caído o red).", err);

                // 2. IMPORTANTE: Cerramos la conexión actual limpia
                if (eventSource) {
                    eventSource.close();
                }

                // 3. Programamos la reconexión en X segundos (ej: 3 segundos)
                reconnectTimeout = setTimeout(() => {
                    console.log("Reintentando conexión SSE...");
                    connect(); // Llamada recursiva
                }, 3000);
            };
        };

        // Iniciamos la conexión por primera vez
        connect();

        // 4. Limpieza final cuando el componente se desmonta (usuario sale de la pantalla)
        return () => {
            console.log("Desmontando SSE hook. Cerrando conexiones.");
            if (eventSource) eventSource.close();
            if (reconnectTimeout) clearTimeout(reconnectTimeout);
        };

    }, [userId]); // Solo reiniciamos todo si cambia el ID del usuario
};

export default useServerSentEvents;